module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cookie-policy.json
// module id = 1712
// module chunks = 41959412057359